import { Component } from '@angular/core';
import { interval } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'casi-ticker',
  imports: [],
  templateUrl: './ticker.html',
  styleUrl: './ticker.scss'
})
export class Ticker {

  counterObservable = interval(1000);

  counter = toSignal(this.counterObservable, { initialValue: 0 });
}
